import React, { useState, useEffect } from 'react';

 
import useTable from "../../useTable";
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";
import { ModalContribuyenteApuesta } from './modalContribuyenteApuesta';
import axios from 'axios';
function TablaUsuarioApuestas() {

    const headCells = [
        { id: 'idcomercio', label: 'CODIGO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'ritm', label: 'RITM', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'rif', label: 'RIF', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'nombre', label: 'NOMBRE', width: '300px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'reprelegal', label: 'N° LICENCIA', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'accion', label: '', width: '180px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    ]

    let op = require('../../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    /* variables de estado */
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [persona, setPersona] = useState();
    const [statusCome, setStatusCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [ipMac, setIpMac] = useState({ ip: localStorage.getItem('ip'), mac: localStorage.getItem('mac') });
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [permiso, setPermiso] = useState();
    const [horaope, setHoraope] = useState();
    const [declaWeb, setDeclaWeb] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mostarModal, setMostrarModal] = useState(false);
    const [comercio, setComercio] = useState();
    const [tipint, setTipint] = useState();
    const [porinteres, setPorinteres] = useState();
    const [porrecargo, setPorrecargo] = useState();
    const [deuda, setDeuda] = useState();
    const [historico, setHistorico] = useState();
    const [consifgApuestas, setConfigApuestas] = useState();
    const [periodo, setPeriodo] = useState();
    const [valorPorce, setValorPorce] = useState();

    const cerrarContri = () => {
        setMostrarModal(false);
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    /* metodo para filtrar la tabla */
    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idcomercio.includes(target.value) || x.ritm.toLowerCase().includes(target.value.toLowerCase()) || x.rif.toLowerCase().includes(target.value.toLowerCase()) || x.nombre.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    };







    /* metodo para cerrar el dialogo de mensaje */

    const handleCloseMensa = () => {
        setMostrar(false);
    }












    /* metodo para abrir el modal y modificar un agente */

    const editarComercio = (item, index) => (event) => {

        event.preventDefault();
        setMostrar5('true')
    };

    const cerrarModalActualizar = () => {


        setMostrar5(false);

    }





    /* *****************************************                Consultas                 ************************************************* */

    const seleccionarRegistros = () => {


        let campos = "*"
        let nomtab = "comercio";
        let orden = "idcomercio";

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;


        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const seleccionarRegistro = (idcomercio) => (e) => {

        e.preventDefault();

        let campos = "*"
        let nomtab = "comercio";
        let nomid = "idcomercio";

        let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idcomercio}&nomtab=${nomtab}&nomid=${nomid}`
        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                if (response.data.idcomercio > 0) {

                    setComercio(response.data)
                    seleccionarDeuda(response.data.idcomercio)
                    setMostrarModal(true);


                }
                setActivate(false);

            }

        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })
    }

    const seleccionarDeuda = (idcomercio) => {

        let interes;

        if (tipint === 1) {

            interes = porinteres
        } else {

            interes = "0.00"
        }

        let endpoint = `${op.conexion}/api/apuestas/deudaapuesta?id=${idcomercio}&fechasis=${fechaSistema}&porrecargo=${porrecargo}&interes=${interes}&tipint=${tipint} `;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status == 200) {

                console.log('Deuda')

                var deu = [];
                var his = [];
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].fechapago === null) {
                        deu.push({
                            anio: response.data[i].anio,
                            mes: response.data[i].mes.replace("'", "").replace("'", ""),
                            monto: response.data[i].mondeu,
                            intereses: response.data[i].intmoradeu,
                            multa: response.data[i].multa,
                            recargo: response.data[i].recargodeu,

                        });
                    } else {
                        his.push({
                            anio: response.data[i].anio,
                            mes: response.data[i].mes.replace("'", "").replace("'", ""),
                            monto: response.data[i].mondeu,
                            intereses: response.data[i].intmoradeu,
                            recargo: response.data[i].recargodeu,
                            multa: response.data[i].multa,
                            descuento: response.data[i].mondescue,
                            recibo: response.data[i].numreci,
                            fechapago: response.data[i].fechapago,
                        });
                    }

                }

                setDeuda(deu);
                setHistorico(his);


            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const seleccionarConfiguracion = () => {
        /* pedir base de datos actualizada */
        let campos = "*"
        let nomtab = "configapuesta";
        let orden = "1";

        let endpoint = op.conexion + `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then((response) => {

            if (response.status == 200) {

                console.log('config')

                setConfigApuestas(response.data[0]);

                setTipint(response.data[0].tipointeres);
                setPorinteres(response.data[0].porcentajeinteres);
                setPorrecargo(response.data[0].porcentajerecargo);

                let periodo;

                switch (parseInt(response.data.periodopago)) {
                    case 1:
                        periodo = 1
                        setPeriodo(1);
                        console.log('caso 1')

                        break;
                    case 2:
                        periodo = 4
                        setPeriodo(4);
                        console.log('caso 2')

                        break;
                    case 3:
                        periodo = 12
                        setPeriodo(12);
                        console.log('caso 12')
                        break;
                }

                if (response.data.valorporcentual == 1) {

                    setValorPorce(100.00)
                } else {
                    setValorPorce(1000.00)
                }

                setActivate(false);
            }

        }).catch((error) => {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const seleccionarValorPetro = () => {

        let endpoint = op.conexion + '/api/efiscal/valorpetro';
    
        axios.get(endpoint, {
          headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        }
        }).then((response) => {
    
          if (response.status == 200) {
    
           /*  setValorUT(response.data.valor); */
            
          }
    
        }).catch((error) => {
    
          setTitulo("ERROR");
          setMsg(error.response.data.message)
          setMostrar(true)
          setActivate(false);
    
        })
    
    }
    




    useEffect(() => {
        seleccionarRegistros()
        seleccionarConfiguracion()
        seleccionarValorPetro()


    }, []);

    return (
        <div className="card">
            <ModalContribuyenteApuesta
                show={mostarModal}
                onHideCancela={cerrarContri}
                comercio={comercio}
                deuda={deuda}
                historico={historico}

            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            {/* /.card-header */}
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <input className="search-input form-control mr-sm-2" style={{ border: '1px solid #007bff' }} type="search" placeholder="Buscar" onChange={handleSearch} aria-label="Search" />
                                    </div>
                                    <div className="col-md-6"></div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idagenteretencion} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "10px" }}>{item.idcomercio}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.ritm}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.rif}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "300px" }}>{item.nombre}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.numerolicencia}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "180px", padding: 0 }}>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(0, 1) !== "1" ? 'none' : '' }} onClick={seleccionarRegistro(item.idcomercio)} className="btn btn-outline-info"><i className="fas fa-search"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">



                </div>
            </div>

        </div>

    );

}

export default TablaUsuarioApuestas;
